import { defineMessages } from 'react-intl';
import { SelectionSchemaExtender } from 'volto-form-block/components/FieldTypeSchemaExtenders/SelectionSchemaExtender';

const messages = defineMessages({
  klaviyo_id: {
    id: 'klaviyo_id',
    defaultMessage: 'Klaviyo id',
  },
  standard: {
    id: 'standard',
    defaultMessage: 'Standard',
  },
  klaviyo_email: {
    id: 'klaviyo_email',
    defaultMessage: 'Email',
  },
  phone_number: {
    id: 'phone_number',
    defaultMessage: 'Phone number',
  },
  first_name: {
    id: 'first_name',
    defaultMessage: 'First name',
  },
  last_name: {
    id: 'last_name',
    defaultMessage: 'Last name',
  },
  organization: {
    id: 'organization',
    defaultMessage: 'Organization',
  },
  country: { id: 'country', defaultMessage: 'Country' },
  city: { id: 'city', defaultMessage: 'City' },
  zip: { id: 'zip', defaultMessage: 'Zip code' },
  region: { id: 'region', defaultMessage: 'Region' },
  address: { id: 'address', defaultMessage: 'Address' },
});

export const klaviyoId = (intl) => {
  return {
    fields: ['klaviyo_id'],
    properties: {
      klaviyo_id: {
        title: intl.formatMessage(messages.klaviyo_id),
        type: 'string',
        choices: [
          ['standard', intl.formatMessage(messages.standard)],
          ['email', intl.formatMessage(messages.klaviyo_email)],
          ['phone_number', intl.formatMessage(messages.phone_number)],
          ['first_name', intl.formatMessage(messages.first_name)],
          ['last_name', intl.formatMessage(messages.last_name)],
          ['organization', intl.formatMessage(messages.organization)],
          ['location.address1', intl.formatMessage(messages.address)],
          ['location.city', intl.formatMessage(messages.city)],
          ['location.zip', intl.formatMessage(messages.zip)],
          ['location.country', intl.formatMessage(messages.country)],
          ['location.region', intl.formatMessage(messages.region)],
        ],
      },
    },
    required: [],
  };
};

export const selectionKlaviyoId = (intl) => {
  const selection = SelectionSchemaExtender(intl);
  const klaviyo = klaviyoId(intl);
  return {
    fields: [...selection.fields, ...klaviyo.fields],
    properties: { ...selection.properties, ...klaviyo.properties },
    required: [...selection.required, ...klaviyo.required],
  };
};
